import { findWrapper } from "./helpers";

export default function() {
  const showMoreAnchors = document.querySelectorAll(".js-show-more-anchor");
  if (!showMoreAnchors.length) return;

  function showLoadMoreAnchor(_button) {
    _button.removeAttribute("aria-hidden");
    _button.removeAttribute("tabindex");
    _button.parentNode.style.transform = "translate(0, 0)";
  }

  function hideLoadMoreAnchor(_button) {
    _button.setAttribute("aria-hidden", true); // Accessibility
    _button.setAttribute("tabindex", "-1"); // Accessibility: hidden elements must not be focusable.
    _button.parentNode.style.transform = "translate(0, 100%)";
  }

  function findTargetItem(anchor, items) {
    let item;
    const buttonRect = anchor.getBoundingClientRect();

    for (let i = 0; i < items.length; i++) {
      const itemRect = items[i].getBoundingClientRect();

      if (itemRect.bottom >= buttonRect.top) {
        item = items[i];
        break;
      }
    }

    return item;
  }

  function configureAnchor(anchor, items) {
    const targetItem = findTargetItem(anchor, items);

    if (targetItem) {
      showLoadMoreAnchor(anchor);

      const anchorHref = `#${targetItem.id}`;
      anchor.href = anchorHref;
    } else {
      hideLoadMoreAnchor(anchor);
    }
  }

  function onContentLoadedShowMoreHandler() {
    for (let i = 0; i < showMoreAnchors.length; i++) {
      const anchor = showMoreAnchors[i];
      const container = findWrapper(anchor, "js-show-more-container");
      const items = container.querySelectorAll(".js-show-more-item");
      let fireScrollHandler = true;

      configureAnchor(anchor, items);

      anchor.addEventListener("click", function() {
        configureAnchor(this, items);
      });

      window.addEventListener("scroll", function() {
        if (fireScrollHandler) {
          fireScrollHandler = false;

          setTimeout(() => {
            configureAnchor(anchor, items);
            fireScrollHandler = true;
          }, 1000);
        }
      });
    }
  }

  window.addEventListener("DOMContentLoaded", onContentLoadedShowMoreHandler);
}
